import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/of';

import { AuthService } from '../services/auth.service';
import { SettingsService } from '../services/settings.service';


import { User } from '../models/user.model';


@Injectable()
export class UserService {
   private controllerURL = 'Users';  // Controllername in der API
   apiURL: string ;                  // URL to web API (API + Controller)
   user: User;
 
  //private apiBasicURL = 'http://localhost:62281/odata/'; 
  private apiBasicURL = 'http://webapilagerservicesowentus.azurewebsites.net/odata/';
  private gesamtURL: string;
  private TOKEN: string;
  
  
  constructor(private http: Http) { 
    this.user = new User();
    // create URL to web API
    this.apiURL = this.getURL(this.controllerURL);
    console.log("apiURL = " + this.apiURL);    
  }

// User posten. Kommt mit SessionGUID=Token und Anmeldedaten zurück
// alternativ: Test mit fixem User
  login(username: string, password: string):  Observable<User>
  {
    this.user.Benutzer = username;
    this.user.Kennwort = password;
    this.user.SessionToken = "-1";
    this.user.ResponseID = -1;
    this.user.ResponseMsg = "Benutzer oder Kennwort falsch";

    const headersOhneAuth: Headers = this.getHeader();

    // für Testuser aktivieren <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
    //if (username === 'seidler' && password === 'seidler') {
      
      // bei Anmeldung restliche Daten noch leer

      // Testuser zurückgeben ------------------
      //this.user = this.getTestUser(this.user);
      //return this.user;
    //}
   // bei Anmeldung restliche Daten noch leer
    this.http
      .post(`${this.apiURL}`, JSON.stringify(this.user), { headers: headersOhneAuth })
      .map(response => response.json())
      .subscribe (
          userData => {
              console.log("zurückgegeben: " + JSON.stringify(userData));
              this.user.Id = userData.Id;
              this.user.Benutzer = userData.Benutzer;
              this.user.Kennwort = "*";
              this.user.Vorname = userData.Vorname;
              this.user.Nachname = userData.Nachname;
              this.user.CustomerName = userData.CustomerName;
              this.user.MandantenName = userData.MandantenName;
              this.user.SessionToken = userData.SessionToken;
              this.user.ResponseID = userData.ResponseID;
              this.user.ResponseMsg = userData.ResponseMsg;
              // abfragen, ob Anmeldung OK
              if (this.user.ResponseID === 1) {
                  
                  sessionStorage.setItem('username', this.user.Benutzer);
                  sessionStorage.setItem('token', this.user.SessionToken);
                  console.log("Anmeldung Token=" + this.user.SessionToken);

              }
              console.log(this.user);
              return Observable.of(this.user);
          },
          error => {
            this.handleError(error) ;
            return Observable.of(this.user); // Sollte leer sein
          }

   
        );

        return Observable.of(this.user); // Sollte leer sein
  }
  
// User posten mit Username und Kennwort: "Abmelden"
  logout(username: string):  Observable<User>
  {
    this.user.Benutzer = username;
    this.user.Kennwort = "Abmelden";
    this.user.SessionToken = "-1";
    this.user.ResponseID = -1;
    this.user.ResponseMsg = "Benutzer abgemeldet";

    const headersOhneAuth: Headers = this.getHeader();

   // bei Abmeldung restliche Daten leer
    this.http
      .post(`${this.apiURL}`, JSON.stringify(this.user), { headers: headersOhneAuth })
      .map(response => response.json())
      .subscribe (
          userData => {
              console.log("Abmeldung zurückgegeben: " + JSON.stringify(userData));
              this.user.Id = userData.Id;
              this.user.Benutzer = userData.Benutzer;
              this.user.Kennwort = "*";
              this.user.Vorname = userData.Vorname;
              this.user.Nachname = userData.Nachname;
              this.user.CustomerName = userData.CustomerName;
              this.user.MandantenName = userData.MandantenName;
              this.user.SessionToken = userData.SessionToken;
              this.user.ResponseID = userData.ResponseID;
              this.user.ResponseMsg = userData.ResponseMsg;
 
              console.log("Abmeldung:" + this.user);
              return Observable.of(this.user);
          },
          error => {
            this.handleError(error) ;
            return Observable.of(this.user); // Sollte leer sein
          }

   
        );

        return Observable.of(this.user); // Sollte leer sein
  }

  


  private handleError(error: any): Observable<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Observable.of(error.message || error);
  }
  
  // Erstellt eine URL aus der BasisURL + dem Controllernamen
  getURL(controller: string): string {
    this.gesamtURL = [this.apiBasicURL, controller].join('');
    console.log("Gesamt-URL:" + this.gesamtURL);
    return  [this.apiBasicURL, controller].join('');
  }

  // Erstellt den Standard Header ohne Session-Token aus der Anmeldung
  getHeader(): Headers {
      const headers: Headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('Accept', 'application/json');
      headers.append('Accept', 'text/plain');
      headers.append('Accept', '*/*');  
      return headers;
  }

// TestUser-Anmeldung statt in WebAPI anmelden
  getTestUser( user : User) {
      user.SessionToken = "b1ff3f7a-484a-47f2-aec4-e9070604b2df";
      user.Id = 1;
      user.CustomerName = "Seidler";
      user.MandantenName = "Seidler Lagerbestand";
      user.Nachname = "Schlestein";
      user.Vorname = "Gerhard";
      user.ResponseID = 1;
      user.ResponseMsg = "Anmeldung erfolgreich";
      return user;
  }


}



// WEBPACK FOOTER //
// D:/Crossplatform/swsLagerinfo/src/app/services/user.service.ts